'use client';

import type {
  GetReverseProposalsServiceRequest,
  GetReverseProposalsServiceResponse,
} from '@musinsa/services-curator';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

export const useReverseProposals = (params: Omit<GetReverseProposalsServiceRequest, 'page'>) => {
  return useInfiniteQuery({
    ...curatorQueries.campaigns.reverseProposals(params),
    initialPageParam: 1,
    getNextPageParam: (lastPage: GetReverseProposalsServiceResponse) =>
      lastPage.pagination.hasNextPage ? lastPage.pagination.nextPage : undefined,
    placeholderData: keepPreviousData,
  });
};
